import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { notificationActions } from '../../notifications/actions/notification';
import { actions as personalActions } from '../../settings/actions/personal';
import { actions } from '../actions/conversation';
import * as conversationsActions from '../actions/conversations';
import Conversation from '../components/Conversation';
import { getLatestFacebookConversation } from '../selectors';

const { conversationsResetUnread } = conversationsActions.actions;
const { notificationTabBadgeReset } = notificationActions;

const mapStateToProps = (state) => {
  return {
    metaConversation: state.conversation.metaConversation,
    isCustomCardMenuOpen: state.settings.personal.isCustomCardMenuOpen,
    latestMessengerConversation: getLatestFacebookConversation(state),
    isFocusMode: state.conversation.isFocusMode,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    conversationGet: bindActionToPromise(dispatch, actions.conversationGet),
    notificationTabBadgeReset: () => dispatch(notificationTabBadgeReset()),
    conversationResetUnread: (payload: { csid: string }) =>
      dispatch(conversationsResetUnread(payload)),
    conversationUnmount: () => dispatch(actions.conversationUnmount()),
    closeSideBarMenu: () =>
      dispatch(
        personalActions.personalCustomCardMenu({
          key: 'isCustomCardMenuOpen',
          value: false,
        }),
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversation);
